function numero (valor) {
  if (valor == null || valor === '') return null
  const n = Number(valor)
  return Number.isFinite(n) ? n : null
}

export function formatearMoneda (valor) {
  const n = numero(valor)
  if (n == null) return '—'
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(n)
}

/** Normaliza un ítem del GET api/referrals (soporta alias de campos). */
export function normalizarItemReferido (raw) {
  const item = raw || {}
  const descuentoAplicado = numero(item.descuento_aplicado)
  const descuentoPendiente = numero(item.descuento_pendiente)
  const montoPagado = numero(
    item.monto_pagado ?? item.pagado_monto ?? item.importe_pagado
  )
  const montoDebia = numero(
    item.monto_debia
    ?? item.monto_esperado
    ?? item.total_debia
    ?? item.debia_pagar
  )
  const folioPago = String(
    item.folio_pago
    ?? item.folio_pago_aplicado
    ?? item.folio_pago_descuento
    ?? item.folio_descuento
    ?? ''
  ).trim()
  const pagado = Boolean(item.pagado)

  return {
    id: item.id,
    prospecto: item.prospecto || item.nombre || 'Sin nombre',
    folioReferido: String(item.folio || item.folio_referido || '').trim(),
    telefono: String(item.telefono || '').trim(),
    pagado,
    pagadoTexto: item.pagado_texto || (pagado ? 'Pagado' : 'Pendiente de pago'),
    descuentoAplicado,
    descuentoPendiente,
    folioPago,
    montoPagado,
    montoDebia,
    tieneDetallePago: descuentoAplicado != null && descuentoAplicado > 0,
  }
}

export function normalizarListaReferidos (data) {
  const body = data || {}
  const items = Array.isArray(body.items) ? body.items.map(normalizarItemReferido) : []
  return {
    items,
    total: Number(body.total) || items.length,
    totalPagados: Number(body.total_pagados) || 0,
    totalDescuentoAplicado: numero(body.total_descuento_aplicado) || 0,
  }
}
